export enum SupportedLanguages {
  EN = 'en',
  DEFAULT_LANGUAGE = EN,
  FR = 'fr',
  PL = 'pl',
  IT = 'it',
  TR = 'tr',
  DE = 'de',
  ES = 'es',
  RU = 'ru',
  UK = 'uk',
}
